import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {
    isLoading: false,
    error: null,
    banners: null,
 
};

export const getBanners = createAsyncThunk(
    "home/get_banners",
    async (_, { dispatch, getState, rejectWithValue }) => {

        try {
            dispatch(getBannersStart());
            const response = await axios.get(
                `home/get_banners.php`
            );
            dispatch(getBannersSuccess(response?.data));
            return response?.data;
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || "Failed to load banners";
            dispatch(getBannersfailure(msg));
            return rejectWithValue(msg);
        }
    }
);



const bannersSlice = createSlice({
    name: "banners",
    initialState,
    reducers: {
        getBannersStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getBannersSuccess(state, action) {
            state.isLoading = false;
            state.banners = action.payload?.data;

        },
        getBannersfailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
       
      
    },
});

export const {
    getBannersStart,
    getBannersSuccess,
    getBannersfailure,
} = bannersSlice.actions;

export default bannersSlice.reducer;
